
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternatives/[brand]",
      function () {
        return require("private-next-pages/alternatives/[brand].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternatives/[brand]"])
      });
    }
  